import React, { Fragment } from 'react';
import { Tooltip, NonIdealState, Button, Position, Intent, Card, InputGroup, Spinner, HTMLSelect } from "@blueprintjs/core";
import '../../../../assets/components/TableRessource.css'
import FixedChannel from './FixedChannel'
import RessourceFullscreenable from '../../Sequences/RessourceFullscreenable'
import Auth from "../../../../services/Auth";
import DialogAddAttribute from '../../Sequences/DialogAddAttribute'
import firebase from 'firebase'
class CreatePanelProtocolMCTable extends React.Component {

    state = {
        loading: true,
        customAttrDialog: false,
        attributesList: []
    }

    withFixedChannel = () => {
        if (this.props.criterias && this.props.criterias.find(crit => crit.isFixed)) {
            return true;
        }
        return false;
    }

    handleChange = (e) => {
        if (this.withFixedChannel()) {
            console.log(e.target.id);
            console.log(parseInt(e.target.id) + 1 )
            const { onChangeCriteriaName } = this.props
    
            onChangeCriteriaName(parseInt(e.target.id) + 1 , e.target.value)
        } else {
            const { onChangeCriteriaName } = this.props
    
            onChangeCriteriaName(e.target.id + 1, e.target.value)
        }

    }

    handleDeleteCriteria = (id) => {
        const { onDeleteCriteria } = this.props;

        onDeleteCriteria(id);
    }

    handleDeleteAttribute = async (attribute, index) => {
        this.props.handleDeleteAttribute(attribute, index)
    }

    moreAttributes = (e) => {
        e.preventDefault()
        if (this.props.attributes) {
            this.props.handleChangeAttribute("UNK", 'UNK', 'UNK', this.props.attributes.length)
            this.props.criterias.forEach((ress, i) => {
                this.props.handleChangeAttributeUnitValue('', this.props.attributes.length, i, true)
            })
        } else {
            this.props.handleChangeAttribute("UNK", 'UNK', 'UNK', 0)
            this.props.criterias.forEach((ress, i) => {
                this.props.handleChangeAttributeUnitValue('', 0, i, true)
            })
        }
    }

    refreshAttributesList = async () => {
        this.setState({ loading: true })
        let attrs
        let that = this
        var ref = firebase.database().ref(`users/${Auth.getUser().uid}/attributes`);
        ref.on('value', function (snapshot) {
            attrs = snapshot.val()
            attrs.sort((a, b) => a.name.localeCompare(b.name))
            that.setState({ attributesList: attrs, loading: false });
        });
    }

    componentDidMount() {
        this.refreshAttributesList()
    }

    render() {
        const { criterias, isDeletingCriteria, onOpenDialog, instances = [], attributes, onOpenDialogFixed } = this.props;

        let fileNumber = criterias.length

        let imageSize = 1
        if (fileNumber > 3) { imageSize = 0.63 }


        if (isDeletingCriteria)
            return (
                <div style={{ marginTop: "20px" }}>
                    <Spinner size={100} />
                </div>
            )
        if (fileNumber < 1 || (fileNumber === 1 && (criterias[0].isFixed === true)))
            return (
                <>
                    <FixedChannel
                        onOpenDialogFixed={onOpenDialogFixed}
                        fixedChannel={criterias.find(criteria => criteria.isFixed === true)}
                        handleDeleteCriteria={this.handleDeleteCriteria}
                    />
                    <NonIdealState
                        icon="selection"
                        title="No Channels"
                        description="You did not add channels yet yet"
                        action={<Button
                            intent={Intent.SUCCESS}
                            disabled={criterias.length >= 5}
                            rightIcon="add"
                            text="Add Channels"
                            onClick={onOpenDialog} />} />
                </>
            );


        if (this.state.loading) {
            return <></>
        } else {
            return (
                <div>
                    <DialogAddAttribute
                        dialogIsOpen={this.state.customAttrDialog}
                        onCloseDialog={() => this.setState({ customAttrDialog: false })}
                        attributes={this.state.attributesList}
                        refreshAttributesList={this.refreshAttributesList}
                    />
                    <FixedChannel
                        onOpenDialogFixed={onOpenDialogFixed}
                        fixedChannel={criterias.find(criteria => criteria.isFixed === true)}
                        handleDeleteCriteria={this.handleDeleteCriteria}
                    />
                    <div className="text-right">
                        <Tooltip
                            disabled={criterias.length < 5}
                            content="You have reach the maximum amount of canals"
                            position={Position.TOP_LEFT} >
                            <Button
                                intent={Intent.SUCCESS}
                                disabled={criterias.length >= 5 || instances.length !== 0}
                                rightIcon="add"
                                text="Add Channel"
                                style={{ marginBottom: '20px' }}
                                onClick={onOpenDialog} />
                        </Tooltip>
                    </div>
                    <Card>
                        <div className="bp3-html-table full-width">
                            <div className='newfiles-container'>
                                <div className={fileNumber > 3 ? 'margin-img-sm' : 'margin-img-lg'}></div>
                                <div className='right-container'>
                                    {criterias.length && criterias
                                        .filter(criteria => !criteria.isFixed)
                                        .map((r, i) => (
                                            <RessourceFullscreenable
                                                key={i}
                                                customClass={fileNumber > 3 ? 'delete-image' : 'delete-image-sm'}
                                                handleDeleteResource={this.handleDeleteCriteria}
                                                imageSize={imageSize}
                                                downloadURL={r.downloadURL}
                                                index={i}
                                                id={r.id}
                                                fileNumber={fileNumber}
                                            />
                                        )
                                        )}
                                </div>
                                <div></div>
                                <div className='align-center'>
                                    Name of the image
                                </div>
                                <div className="right-container">
                                    {criterias.length && criterias
                                        .filter(criteria => !criteria.isFixed)
                                        .map((r, i) =>
                                            < div key={i}>
                                                <InputGroup
                                                    className='images-inputs'
                                                    id={i}
                                                    onChange={this.handleChange}
                                                    name="name"
                                                    // disabled={submiting}
                                                    defaultValue={r.name}
                                                />
                                            </div>
                                        )}
                                </div>
                            </div>
                            <br />
                            <hr className='hidden-xs hidden-sm' />
                            <br />
                            <div
                                className="newfiles-container"
                            >
                                {attributes && attributes.map((attribute, attr) =>
                                    <Fragment key={attr} >
                                        <div className="attribute-container">
                                            <HTMLSelect
                                                fill={true}
                                                name="attributes"
                                                defaultValue={attribute.ref || "UNK"}
                                                onChange={(e) => {
                                                    let myAttribute = this.state.attributesList.find(a => a.ref === parseInt(e.target.value))
                                                    this.props.handleChangeAttribute(myAttribute.name, myAttribute.unit, e.target.value.toString(), attr)
                                                }}
                                                className='images-inputs'
                                            >
                                                <option disabled value="UNK">
                                                    Choose an attribute
                                            </option>
                                                {this.state.attributesList.map((userAttr, index) =>
                                                    <option key={index} value={userAttr.ref}>{userAttr.name} - {userAttr.unit}</option>
                                                )}
                                            </HTMLSelect>
                                        </div>
                                        <div
                                            className="right-container">
                                            {criterias && criterias
                                                .filter(criteria => !criteria.isFixed)
                                                .map((r, ress) =>
                                                    <div key={ress}>
                                                        <InputGroup
                                                            className='images-inputs'
                                                            id="input-right"
                                                            onChange={(e) => this.props.handleChangeAttributeUnitValue(e.target.value, attr, ress, true)}
                                                            name="quantity"
                                                            type='number'
                                                            step="0,001"
                                                            placeholder='xx,xx'
                                                            defaultValue={(r.attributes && r.attributes[attr]) ? r.attributes[attr].quantity : 0}
                                                        />
                                                    </div>
                                                )}
                                        </div>
                                        <div className="bp3-icon-large bp3-icon-trash trash" onClick={() => this.handleDeleteAttribute(attribute, attr)}></div>
                                    </Fragment>
                                )}
                            </div>
                            <br /><br />
                            <Button intent={Intent.PRIMARY} value="UNK" onClick={this.moreAttributes}>Add attribute</Button><br /><br />
                            <Button intent={Intent.PRIMARY} value="UNK" onClick={() => this.setState({ customAttrDialog: true })}>Create custom attribute</Button>
                        </div>
                    </Card>
                </div >
            )
        }
    }
}

export default CreatePanelProtocolMCTable;